export const getSelectedPersonIds = state => state.selectList.selectedPersonIds;
export const getSelectedCompanyIds = state => state.selectList.selectedCompanyIds;
